(function($) {

references_carousel = {

    init: function () {
        $(document).ready(function(){
            $('.references_carousel').slick({
                speed: 1000,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
				    {
				      breakpoint: 1024,
				      settings: {
				        slidesToShow: 3,
				        slidesToScroll: 3,
				        infinite: true,
				      }
				    },
				    {
				      breakpoint: 600,
				      settings: {
				        slidesToShow: 2,
				        slidesToScroll: 2
				      }
				    },
				    {
				      breakpoint: 480,
				      settings: {
				        slidesToShow: 1,
				        slidesToScroll: 1
				      }
				    }
				]
            });
        });
    }
};

})(jQuery);